import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import { EllipsisMenu } from '@components/EllipsisMenu'
import TabsCarousel from '@components/TabsCarousel'
import AddIcon from '@mui/icons-material/Add'
import CreateIcon from '@mui/icons-material/Create'
import OutputOutlinedIcon from '@mui/icons-material/OutputOutlined'
import Button from '@mui/material/Button'

import { ActionItemsWrapper, StyledAddIconWrapper, TabsWrapper, TopTabsNavigationContainer } from './index.styles'
import { ShortlistHeaderProps } from './types'

export const ShortlistHeader = ({
  tabs,
  activeTab,
  manageMenuItems,
  canAddShortlists,
  eventsLoaded,
  shortlistsLoaded,
  onTabChange,
  onProfileDrop,
  onAddShortlistButtonClick,
  onEditShortlistsClick,
  onImportProspectsClick,
}: ShortlistHeaderProps) => {
  const { t } = useTranslation()

  return (
    <TopTabsNavigationContainer>
      {tabs?.length ? (
        <TabsWrapper>
          <TabsCarousel tabs={tabs} value={activeTab} onChange={onTabChange} acceptDrops="profile" handleDrop={onProfileDrop} />
        </TabsWrapper>
      ) : null}

      <ActionItemsWrapper>
        {manageMenuItems?.length > 0 ? (
          <EllipsisMenu
            iconButtonProps={{ color: 'primary' }}
            menuProps={{ PaperProps: { sx: { minWidth: 180 } } }}
            items={manageMenuItems}
          />
        ) : (
          <>
            {canAddShortlists && (
              <Button
                variant="text"
                color="primary"
                startIcon={
                  <StyledAddIconWrapper>
                    <AddIcon color="inherit" sx={{ marginTop: '-10px', marginLeft: '-10px', fontSize: '32px' }} />
                  </StyledAddIconWrapper>
                }
                id="shortlist-add_new"
                onClick={onAddShortlistButtonClick}
              >
                {t(translationKeys.ADD_YOUR_CUSTOM_LIST)}
              </Button>
            )}
            {shortlistsLoaded && (
              <Button
                variant="text"
                color="primary"
                startIcon={<CreateIcon color="inherit" sx={{ fontSize: '16px !important', marginRight: '-2px' }} />}
                onClick={onEditShortlistsClick}
                id="shortlist-edit"
              >
                {t(translationKeys.EDIT_CUSTOM_LISTS)}
              </Button>
            )}
            {eventsLoaded && (
              <Button
                variant="text"
                color="primary"
                startIcon={<OutputOutlinedIcon color="inherit" sx={{ fontSize: '32px' }} />}
                onClick={onImportProspectsClick}
                sx={{ maxWidth: '200px' }}
                id="shortlist-p1_import"
              >
                {t(translationKeys.IMPORT_PROSPECTS_FROM)}
              </Button>
            )}
          </>
        )}
      </ActionItemsWrapper>
    </TopTabsNavigationContainer>
  )
}
